<template>
  <v-row class="pt-0" style="position: relative;">
    <v-col>
      <v-sheet color="#222222" width="100%">
        <v-row>
          <v-col cols="3" class="text-left"
            ><span class="ml-3 feature-content-text">{{
              $t("chapter.featuredContent")
            }}</span></v-col
          >
          <v-col cols="6" class="pa-0">
            <div
              style="
                margin: 0px auto;
                width: 100%;
                text-align: center;
                backround-color: #222222;
              "
            >
              <v-hover>
                <template v-slot:default="{ hover }">
                  <v-img
                    v-if="chapterMediaObject"
                    style="margin: 0px auto"
                    max-height="100%"
                    max-width="100%"
                    :key="chapterMediaObject.id"
                    :src="chapterMediaObject.contentUrl"
                  >
                    <v-fade-transition>
                      <v-overlay absolute :value="hover" v-if="!loading">
                        <v-btn
                          color="primaryAction"
                          @click="$refs.thumbnailUpload.click()"
                        >
                          {{ $t("chapter.image.changeImage") }}
                        </v-btn>
                      </v-overlay>
                    </v-fade-transition>
                  </v-img>
                  <v-sheet
                    height="100%"
                    elevation="0"
                    color="#222222"
                    v-else
                    class="pa-0"
                    style="position: relative;"
                  >
                    <img style="width: 100%; background-color: #EFEFEF; margin-bottom: -7px;" />
                    <v-overlay absolute opacity="0">
                    <div style="color: black;">
                    <v-icon color="primary">mdi-upload</v-icon> <br />
                        {{ $t("chapter.image.addImage") }}
                    </div>
                    </v-overlay>
                    <v-fade-transition>
                      <v-overlay absolute :value="hover" v-if="!loading">
                        <v-btn
                          color="primaryAction"
                          @click="$refs.thumbnailUpload.click()"
                        >
                          {{ $t("chapter.image.addImage") }}
                        </v-btn>
                      </v-overlay>
                    </v-fade-transition>
                  </v-sheet>
                </template>
              </v-hover>
              <input
                v-show="false"
                ref="thumbnailUpload"
                type="file"
                :accept="imageFormats"
                @change="onFileUpload($event)"
              />
            </div>
          </v-col>
          <v-col cols="3" class="text-right pr-5">
            <v-row>
              <v-col>
                <v-tooltip
                  left
                  max-width="500px"
                  open-on-click
                  color="secondaryBackground"
                  open-delay="1000"
                  :open-on-hover="false"
                  nudge-bottom="70"
                >
                  <template v-slot:activator="{ on, attrs, value }">
                      <v-icon v-on="on" style="background-color: white; background-size: 90%; border-radius: 50%" v-bind="attrs" dark :color="value ? 'primary' : '#797979'" size="40">mdi-information</v-icon>
                  </template>
                  <v-container class="text-left black--text">
                    <v-row
                      ><v-col
                        >{{ $t('chapter.featuredContentDescription') }}</v-col
                      ></v-row
                    >
                    <v-row
                      ><v-col
                        ><strong>{{ $t('chapter.image.imageRequirements') }}</strong><br /> <span v-html="$t('chapter.image.imageRequirementsText', { maxSizeMb: 5 })" />
</v-col> </v-row
                    >
                  </v-container>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row align="end">
              <v-col>
                <v-sheet v-if="loading" color="secondaryBackground" width="200px" class="text-left pa-4 rounded-lg" style=" position: absolute; right: 20px; bottom: 10px;">
                  {{ $t("forms.uploadingShort") }}
                  <v-progress-linear
                    class="mt-3"
                    indeterminate
                    background-color="white"
                    rounded
                    color="primaryAction darken-2"
                    height="8px"
                  ></v-progress-linear>
                </v-sheet>
                <UploadErrorMessage :errorMessage="errorMessage" :loading="loading"  style=" position: absolute; right: 20px; bottom: 10px; text-align: center" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>
  </v-row>
</template>
<script>
import mediaObjectUpload from "@/helpers/mediaObjectUpload"
import { IMAGE_FORMATS, MAX_IMAGE_UPLOAD_BYTES, MAX_IMAGE_UPLOAD_MEGABYTES } from "@/const";
import { AUTH_TOKEN } from "@/apollo/vue-apollo";
import { chapterQueries } from "@/graphql/ChapterQueries";
import UploadErrorMessage from '@/components/TextEditor/UploadErrorMessage.vue';
export default {
  props: {
    chapterId: String,
  },
  components: {
    UploadErrorMessage
  },
  apollo: {
    chapterMediaObject: {
      query: chapterQueries.getChapterWithFeaturedMediaObject,
      fetchPolicy: "network-only",
      variables() {
        return {
          id: this.chapterId,
        };
      },
      error(error) {
        console.log(error);
      },
      update(data) {
        return data.chapter.featuredMediaObject;
      },
    },
  },
  data() {
    return {
      errorMessage: null,
      loading: false,
      rules: {
        imageSize: (value) => !value || value.size < MAX_IMAGE_UPLOAD_BYTES,
      },
    };
  },
  computed: {
    imageFormats() {
      return IMAGE_FORMATS;
    },
    serverHost() {
      return process.env.VUE_APP_SERVER_HOST;
    },
    jwt() {
      return localStorage.getItem(AUTH_TOKEN);
    },
  },
  methods: {
    async onFileUpload(event) {
      try {
        this.loading = true;
        this.errorMessage = null
        await mediaObjectUpload(event, this.jwt, MAX_IMAGE_UPLOAD_BYTES, { bodyFormData: { chapterId: this.chapterId } })
        // TODO - update cache with response rather than reloading image
        this.$apollo.queries.chapterMediaObject.refresh();
        this.loading = false;
      } catch (error) {
        this.loading = false;

        if (error.name && error.name == "FileTooLargeError" ) {
          this.errorMessage = this.$t('register.imageTooLarge', { maxImageSize: MAX_IMAGE_UPLOAD_MEGABYTES })
        }
        else {
          this.errorMessage = error.message;
        }
      }
    },
  },
};
</script>
<style scoped>
h1 {
  color: var(--v-accentElement-base);
}
.thumbnail-overlay {
  background-color: rgba(0, 0, 0, 0.7);
}

.feature-content-text {
  color: var(--v-accentElement-base);
}
</style>